import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
    className?: string;
    hasSeperator?: boolean;
};

export const RatingSection = ({ children, className, hasSeperator }: Props) => {
    return (
        <>
            {hasSeperator && (
                <div
                    aria-orientation="vertical"
                    className="h-lg w-px bg-border-secondary"
                    role="separator"
                />
            )}
            <div
                className={cn('flex flex-col items-center border-b-0 border-border-secondary pb-xs pt-2xs', className)}
            >
                {children}
            </div>
            {hasSeperator && (
                <div
                    aria-orientation="vertical"
                    className="h-lg w-px bg-border-secondary"
                    role="separator"
                />
            )}
        </>
    );
};
